import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AppNavbar from "../components/console/AppNavbar";
import MainGrid from "../components/console/MainGrid";
import SideMenu from "../components/console/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import EventDialog from "../components/console/EventDialog";
import { useUserEvents } from "../contexts/UserEvent";

export default function Dashboard(props: { disableCustomTheme?: boolean }) {
  const { fetchUrls } = useUserEvents();
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleClickOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);

  const handleDialogSuccess = () => {
    setDialogOpen(false);
    fetchUrls();
  };

  return (
    <AppTheme {...props}>
      <>
        {/* Meta tags for SEO */}
        <Helmet>
          <title>Console | Event Spy</title>
        </Helmet>
      </>
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          background:
            "radial-gradient(circle at top left, #041C2C 0%, #22143C 100%)",
        }}
      >
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: "auto",
            pt: { xs: 10, md: 2 },
          }}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                width: "100%",
                color: "white",
                mb: 2,
              }}
            >
              Dashboard
            </Typography>
            <MainGrid onAddNewClick={handleClickOpen} onRefresh={fetchUrls} />
            <EventDialog
              open={dialogOpen}
              mode="add"
              onClose={handleDialogClose}
              onSuccess={handleDialogSuccess}
            />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
